<script>
const appConfig = require('./app.config')
import popUp from "@components/Notification.vue";

export default {
  components: { popUp },
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      // return title ? `${title} | ${appConfig.title}` : appConfig.title
      return title || appConfig.TITLE
    },
  },
  data() {
    return {
      environment: process.env.NODE_ENV,
      refreshing: false,
      worker: null,
      updateExists: false,
      isUpdateSW: false,
    };
  },
  mounted() {
    window.addEventListener("message", (e) => {
      if (e.data.msg === "SW_UPDATED") {
        window.caches.keys().then((cache) => {
          cache.forEach((name) => {
            window.caches.delete(name);
          });
        });
        this.isUpdateSW = true;
      }
    });
  },
  created(){
    // // Listen for swUpdated event and display refresh snackbar as required.
    // document.addEventListener("swUpdated", this.showRefreshUI, { once: true });
    // // Refresh all open app tabs when a new service worker is installed.
    // navigator.serviceWorker && navigator.serviceWorker.addEventListener(
    //     // triggered by registration.claim
    //     "controllerchange",
    //     () => {
    //       if (this.refreshing) return;
    //       this.refreshing = true;
    //       console.log("controllerchange triggered, -> auto refresh!!");
    //       window.location.reload();
    //     }
    //   );
  },
  methods: {
    // showRefreshUI(e) {
    //   console.log("into showRefreshUI(e):", e)
    //   // Display a button inviting the user to refresh/reload the app due
    //   // to an app update being available.
    //   // The new service worker is installed, but not yet active.
    //   // Store the ServiceWorkerRegistration instance for later use.
    //   if (e.detail) {
    //     this.worker = e.detail; // reg
    //     this.updateExists = true;
    //     console.log("Showing refresh button.");
    //     console.log(this.worker);
    //   } else {
    //     console.warn("No worker data found!");
    //   }
    // },
    // refreshApp() {
    //   console.log("skipWaiting started");
    //   console.log(this.worker);
    //   // Handle a user tap on the update app button.
    //   this.updateExists = false;
    //   // Protect against missing registration.waiting.
    //   if (!this.worker || !this.worker.waiting) {
    //     console.warn("No worker data found when trying to refresh!");
    //     return;
    //   }
    //   if (this.worker || this.worker.waiting){
    //     try {
    //       this.worker.waiting.postMessage({type:'SKIP_WAITING'});
    //     } catch(error){
    //       console.log("controlled worker error 1: ", error)
    //       try {
    //         this.worker.postMessage({ type: "SKIP_WAITING" });
    //       } catch(error2){
    //         console.log("controlled worker error 2:", error2)
    //       }
    //     }
    //     console.log("skipWaiting finished");
    //   }
    // }
    updateWindow() {
      window.location.reload();
    },
  }
}
</script>

<template>
  <div id="app">
    <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
    <RouterView :key="$route.fullPath" />
    <notifications group="foo" classes="custom-vue-notification" />
    <popUp title="Nueva versión" msg="Por favor refresque la página" v-if="isUpdateSW" @onSubmit="updateWindow" />
    <!-- <b-button
      v-if="updateExists && environment !== 'development'"
      block variant="info" size="lg"
      @click="refreshApp"
    ><b-icon-upload class="mr-1" /> Nueva versión disponible! click para actualizar</b-button> -->
    
    <!-- <b-alert v-else variant="info" show dismissible >No hay actualizaciones</b-alert> -->
  </div>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Design variables and utilities from src/design.
@import '@design';
</style>
